// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompanySettings_form__K5gt8 {
  height: auto !important;
  padding: 8px 20px 20px;
}

.CompanySettings_grid__pm-1E {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px 24px;
}

.CompanySettings_full__J5kn9 {
  grid-column: 1/-1;
}

.CompanySettings_hint__hLh62 {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: var(--m-text-muted, #6b7280);
}

@media (max-width: 767px) {
  .CompanySettings_grid__pm-1E {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/pages/CompanySettings/CompanySettings.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,mCAAA;AACF;;AAEA;EACE;IACE,0BAAA;EACF;AACF","sourcesContent":[".form {\n  height: auto !important;\n  padding: 8px 20px 20px;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 16px 24px;\n}\n\n.full {\n  grid-column: 1 / -1;\n}\n\n.hint {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--m-text-muted, #6b7280);\n}\n\n@media (max-width: 767px) {\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `CompanySettings_form__K5gt8`,
	"grid": `CompanySettings_grid__pm-1E`,
	"full": `CompanySettings_full__J5kn9`,
	"hint": `CompanySettings_hint__hLh62`
};
export default ___CSS_LOADER_EXPORT___;
